import React, { useState } from 'react';
import { Button, TextInput } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import styles from '../Fastlane.module.less';

const BillingAddressForm = ({
  billingAddress: {
    addressLine1 = '',
    addressLine2 = '',
    adminArea2 = '',
    adminArea1 = '',
    postalCode = '',
    countryCode = ''
  } = {},
  onSubmit
}) => {
  const [formData, setFormData] = useState({
    addressLine1,
    addressLine2,
    adminArea2,
    adminArea1,
    postalCode,
    countryCode
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ address: formData });
  };

  return (
    <form className={styles.address_form} onSubmit={handleSubmit}>
      <TextInput
        type="text"
        name="addressLine1"
        value={formData.addressLine1}
        onChange={handleChange}
        autoComplete="address-line1"
        label="Address Line 1"
        required
        className={styles.address_form_field}
      />
      <TextInput
        type="text"
        name="addressLine2"
        label="Apt., ste., bldg. (optional)"
        autoComplete="address-line2"
        value={formData.addressLine2}
        onChange={handleChange}
        className={styles.address_form_field}
      />
      <div className={styles.address_form_field_container}>
        <TextInput
          type="text"
          name="adminArea2"
          autoComplete="address-level2"
          value={formData.adminArea2}
          onChange={handleChange}
          label="City"
          required
          className={styles.address_form_field}
        />
        <TextInput
          type="text"
          name="adminArea1"
          autoComplete="address-level1"
          value={formData.adminArea1}
          onChange={handleChange}
          label="State"
          required
          className={styles.address_form_field}
        />
      </div>
      <div className={styles.address_form_field_container}>
        <TextInput
          name="postalCode"
          value={formData.postalCode}
          onChange={handleChange}
          autoComplete="postal-code"
          label="ZIP code"
          required
          className={styles.address_form_field}
        />
        <TextInput
          name="countryCode"
          value={formData.countryCode}
          onChange={handleChange}
          autoComplete="country"
          label="Country (eg. US, GB)"
          required
          className={styles.address_form_field}
        />
      </div>
      <div className={styles.cta_button_container}>
        <Button type="submit">Submit</Button>
      </div>
    </form>
  );
};

export default BillingAddressForm;

BillingAddressForm.propTypes = {
  billingAddress: PropTypes.object,
  onSubmit: PropTypes.func.isRequired
};

BillingAddressForm.defaultProps = {
  billingAddress: {}
};
